import {defineStore} from "pinia";
import {useShopInfos} from "~/store/shopInfosStore";

export const useProductStore = defineStore("product", ()=>{
    const richtigMessen = ref("");
    const highlights  = ref([] as any[]);
    const technologien = ref([] as any[]);
    const shopInfos = useShopInfos();
    const actions = {
        getRichtigMessenInfo: computed(() => richtigMessen.value),
        getTechnologien: computed(() => technologien.value),
        getHighlights: computed( ()=> highlights.value || []),
        SET_RICHTIG_MESSEN_INFO(content:string):void{
            richtigMessen.value = content;
        },
        SET_PRODUCT_DETAILS(data:{highlights:any[], technologien:any[]}):void{
            highlights.value = data.highlights;
            technologien.value = data.technologien;
        },
        loadSizesInfo:(payload:{sport:string, webproduct:string})=>{
            useFetch(`/shop_php/loadSizesInfo.php?sport=${payload.sport}&land=${shopInfos.getShopLand}&sprache=${shopInfos.getShopSprache}&product=${payload.webproduct}`)
                .then((response)=>actions.SET_RICHTIG_MESSEN_INFO(JSON.parse(response.data.value).content));

        },
        loadProductDetails:(payload:{sport:string, webproduct:string, saveID:number})=>{
            useFetch(`/shop_php/loadProductDetails.php?sport=${payload.sport}&sprache=${shopInfos.getShopSprache}&product=${payload.webproduct}&saveID=${payload.saveID}&land=${shopInfos.getShopLand}`
            ).then((response)=> actions.SET_PRODUCT_DETAILS(JSON.parse(response.data.value)));
        }
    }

    return actions;

})
